import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyItems: 'center',
    height: '100px',
    flexDirection: 'column',
    zIndex: 2,
    backgroundColor: '#3C419A',
  },
  arrowButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '25px',
    height: '25px',
    border: 'solid 1px rgba(255, 255, 255, 0.2)',
    zIndex: 2,
  },
  arrowButtonActive: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#34365E',
    },
  },
  arrowButtonDisabled: {
    pointerEvents: 'none',
  },
  arrowIcon: {
    width: '15px',
    height: '15px',
    cursor: 'pointer',
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
}));
